import { DadosTabela } from 'models/Geral/DadosTabela'

export type DadosComponentesProjeto = {
  academiaCobertaArea: string
  coworkingArea: string
  churrasqueiraArea: string
  espacoMulherArea: string
  espacoKidsArea: string
  garrafaoBasqueteArea: string
  guaritaArea: string
  lavanderiaArea: string
  piscinaArea: string
  petCareArea: string
  petPlaceArea: string
  playgroundArea: string
  quadraArea: string
  quadraCobertaAlambradoArea: string
  salaoFestasGourmetArea: string
  salaoJogosArea: string
  saunaArea: string
  spaArea: string
  vestiarioArea: string
}

export const dadosComponentesProjetoValorDefault = {
  academiaCobertaArea: '',
  coworkingArea: '',
  churrasqueiraArea: '',
  espacoMulherArea: '',
  espacoKidsArea: '',
  garrafaoBasqueteArea: '',
  guaritaArea: '',
  lavanderiaArea: '',
  piscinaArea: '',
  petCareArea: '',
  petPlaceArea: '',
  playgroundArea: '',
  quadraArea: '',
  quadraCobertaAlambradoArea: '',
  salaoFestasGourmetArea: '',
  salaoJogosArea: '',
  saunaArea: '',
  spaArea: '',
  vestiarioArea: ''
} as DadosComponentesProjeto

export const inicializarDadosTabelaComponenteProjeto = (dadosComponentesProjeto: DadosComponentesProjeto): DadosTabela[] => {
  return [
    {
      descricao: 'Academia Coberta',
      id: 'rowAcademiaCoberta',
      nome: 'academiaCobertaArea',
      valor: dadosComponentesProjeto.academiaCobertaArea
    },
    { descricao: 'Coworking', id: 'rowCoworking', nome: 'coworkingArea', valor: dadosComponentesProjeto.coworkingArea },
    { descricao: 'Churrasqueira', id: 'rowChurrasqueira', nome: 'churrasqueiraArea', valor: dadosComponentesProjeto.churrasqueiraArea },
    { descricao: 'Espaço Mulher', id: 'rowEspacoMulher', nome: 'espacoMulherArea', valor: dadosComponentesProjeto.espacoMulherArea },
    { descricao: 'Espaço Kids', id: 'rowEspacoKids', nome: 'espacoKidsArea', valor: dadosComponentesProjeto.espacoKidsArea },
    {
      descricao: 'Garrafão de Basquete',
      id: 'rowGarrafaoBasquete',
      nome: 'garrafaoBasqueteArea',
      valor: dadosComponentesProjeto.garrafaoBasqueteArea
    },
    { descricao: 'Guarita', id: 'rowGuarita', nome: 'guaritaArea', valor: dadosComponentesProjeto.guaritaArea },
    { descricao: 'Lavanderia', id: 'rowLavanderia', nome: 'lavanderiaArea', valor: dadosComponentesProjeto.lavanderiaArea },
    { descricao: 'Piscina', id: 'rowPiscina', nome: 'piscinaArea', valor: dadosComponentesProjeto.piscinaArea },
    { descricao: 'Pet Care', id: 'rowPetCare', nome: 'petCareArea', valor: dadosComponentesProjeto.petCareArea },
    { descricao: 'Pet Place', id: 'rowPetPlace', nome: 'petPlaceArea', valor: dadosComponentesProjeto.petPlaceArea },
    { descricao: 'Playground', id: 'rowPlayground', nome: 'playgroundArea', valor: dadosComponentesProjeto.playgroundArea },
    { descricao: 'Quadra', id: 'rowQuadra', nome: 'quadraArea', valor: dadosComponentesProjeto.quadraArea },
    {
      descricao: 'Quadra Coberta com Alambrado',
      id: 'rowQuadraCobertaAlambrado',
      nome: 'quadraCobertaAlambradoArea',
      valor: dadosComponentesProjeto.quadraCobertaAlambradoArea
    },
    {
      descricao: 'Salão de Festas Gourmet',
      id: 'rowSalaoFestasGourmet',
      nome: 'salaoFestasGourmetArea',
      valor: dadosComponentesProjeto.salaoFestasGourmetArea
    },
    { descricao: 'Salão de Jogos', id: 'rowSalaoJogos', nome: 'salaoJogosArea', valor: dadosComponentesProjeto.salaoJogosArea },
    { descricao: 'Sauna', id: 'rowSauna', nome: 'saunaArea', valor: dadosComponentesProjeto.saunaArea },
    { descricao: 'SPA', id: 'rowSpa', nome: 'spaArea', valor: dadosComponentesProjeto.spaArea },
    { descricao: 'Vestiário', id: 'rowVestiario', nome: 'vestiarioArea', valor: dadosComponentesProjeto.vestiarioArea }
  ]
}
